import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDocument = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6 11V6.20001C6 5.07991 6 4.51986 6.21799 4.09204C6.40973 3.71572 6.71547 3.40973 7.0918 3.21799C7.51962 3 8.08009 3 9.2002 3H13.6747C14.1639 3 14.4086 3 14.6388 3.05526C14.8428 3.10425 15.0379 3.18508 15.2168 3.29474C15.4186 3.41842 15.5916 3.59135 15.9375 3.93726L19.063 7.06274C19.4089 7.40864 19.5814 7.5816 19.705 7.78343C19.8147 7.96238 19.8953 8.15744 19.9443 8.36151C19.9996 8.59169 20 8.83632 20 9.3255V17.8C20 18.9201 20.0002 19.4801 19.7822 19.908C19.5905 20.2843 19.2841 20.5902 18.9078 20.782C18.48 21 17.9201 21 16.8 21H13M9 14L11 16M20.0002 9H17.2002C16.0801 9 15.5196 8.99997 15.0918 8.78198C14.7155 8.59024 14.4097 8.28429 14.218 7.90797C14 7.48014 14 6.9201 14 5.8V3M4 21V18.5L11.5 11L14 13.5L6.5 21H4Z",
		stroke: "#324051",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgDocument;
